import { Link } from "react-router-dom";
import { useLanguage } from "@/context/AppContext";

export default function Footer() {
  const { t } = useLanguage();

  const links = [
    ["#story", t.nav.story],
    ["#family", t.nav.family],
    ["#ventures", t.nav.ventures],
    ["#values", t.nav.values],
    ["#contact", t.nav.contact],
  ];

  return (
    <footer data-testid="site-footer">
      <div className="footer-brand">
        <div className="mini-mark">10</div>
        <div>
          <strong>My10Sons</strong>
          <small>{t.brandTag}</small>
        </div>
      </div>
      <div className="footer-links">
        {links.map(([href, label]) => (
          <a key={href} href={href} data-testid={`footer-link-${href.slice(1)}`}>
            {label}
          </a>
        ))}
        <Link to="/admin" data-testid="footer-admin-link">
          {t.nav.admin}
        </Link>
      </div>
      <div className="copyright">© {new Date().getFullYear()} {t.footer.rights}</div>
    </footer>
  );
}
